// extracted by mini-css-extract-plugin
module.exports = {"map":"Map__map__2bczx"};